// extracted by mini-css-extract-plugin
module.exports = {"Category":"Category_Category__2UPXC","Category__list":"Category_Category__list__2dn_x"};